/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Notes
 */
export interface Notes {
}

/**
 * Check if a given object implements the Notes interface.
 */
export function instanceOfNotes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NotesFromJSON(json: any): Notes {
    return NotesFromJSONTyped(json, false);
}

export function NotesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notes {
    return json;
}

export function NotesToJSON(value?: Notes | null): any {
    return value;
}

